/*
 * Störfeuer – 60-Sekunden-Fokusspiel für Synapshot.
 * Bindet sich an jedes Element mit [data-stoerfeuer]. Optionen per data-Attribut:
 *   data-code        Rabattcode für den Erstkauf (Standard: STOERFEUER)
 *   data-redirect    Ziel nach dem Einlösen (Standard: /products/2er-pack)
 *   data-shop        Shop-Basis-URL, nur für die Vorschau außerhalb von Shopify nötig
 *   data-logo        Logo-URL (muss same-origin oder CORS-fähig sein, sonst geht die Teilen-Karte nicht)
 *   data-share-url   Adresse, die auf der Teilen-Karte steht
 *   data-slogan      Claim auf der Ergebnisseite (Standard: Train your brain.)
 *   data-produkt-slogan Produkt-Slogan über dem Code (Standard: Optimize your brain.)
 *   data-claim       Produktzeile über dem Code (Standard: Synapshot. Kein Kick, kein Absturz.)
 *   data-rabatt      Wert des Codes, wie er im Text steht (Standard: 10 %)
 *   data-klaviyo-form ID eines Klaviyo-Formulars mit eigenem Auslöser; leer = Anmelde-Block ausgeblendet
 */
(function () {
  'use strict';

  var ROUND = 60;
  var PHASES = [
    { name: 'Sammeln', title: 'Phase 1 · Sammeln', sub: 'Volle Punkte einsammeln. Serie halten.',
      real: 0.58, life: 2.5, decoy: 0, kick: 0, note: 0, drift: 0.45, move: 0 },
    { name: 'Filtern', title: 'Phase 2 · Filtern', sub: 'Hohle Punkte sind Fälschungen. Nachrichten auch.',
      real: 0.56, life: 2.2, decoy: 0.9, kick: 0, note: 2.8, drift: 0.8, move: 18 },
    { name: 'Durchhalten', title: 'Phase 3 · Durchhalten', sub: 'Blitze geben dir einen Kick. Und dann den Absturz.',
      real: 0.52, life: 1.9, decoy: 0.75, kick: 3.4, note: 1.9, drift: 1.15, move: 46 }
  ];

  var NOTES = [
    ['Kollege', '#5b8cff', 'Sag mal, hast du dir grad was in die Nase gesprüht?'],
    ['Mama', '#ff8a5b', 'Ruf mal zurück. Ist nichts Schlimmes. Glaub ich.'],
    ['Story', '#c86bff', 'Dein Ex hat deine Story angesehen.'],
    ['System', '#ff4d4d', 'Akku 3 %'],
    ['Familie (Gruppe)', '#3ddc84', 'Onkel Gerd: Wer hat „Koksersatz“ in den Chat geschrieben???'],
    ['Paketdienst', '#f5b400', 'Zustellung gescheitert. Du warst angeblich nicht zu Hause.'],
    ['Chef', '#5b8cff', 'Hast du kurz fünf Minuten?'],
    ['Kalender', '#ff4d4d', 'In 2 Min.: „Kurzer Sync“ (90 Minuten)'],
    ['Nachbar', '#3ddc84', 'Dein Auto steht wieder halb in meiner Einfahrt.'],
    ['Match', '#ff5ca8', 'Neues Match! Ihr mögt beide „Spaziergänge“.'],
    ['Bank', '#00b4d8', 'Ungewöhnliche Abbuchung: 49,99 € für „Premium“.'],
    ['Mitbewohner', '#f5b400', 'Wer hat meinen Joghurt gegessen?'],
    ['Schrittzähler', '#3ddc84', 'Heute 112 Schritte. Alles okay bei dir?'],
    ['Abi 2014 (Gruppe)', '#3ddc84', 'Klassentreffen!!! 87 neue Nachrichten'],
    ['Update', '#8a94a6', 'Neustart erforderlich. Jetzt? Jetzt? Jetzt?'],
    ['Oma', '#ff8a5b', 'WIE MACHT MAN HIER KLEINBUCHSTABEN'],
    ['Streaming', '#ff4d4d', 'Neue Staffel ist da. Alle Folgen. Sofort.'],
    ['Büro (Gruppe)', '#3ddc84', 'Kuchen in der Küche!!! Schnell!!!'],
    ['Unbekannt', '#8a94a6', 'Hallo, hier ist dein Paket. Bitte hier klicken.'],
    ['Ex', '#c86bff', 'Hey. Lange nicht gehört.'],
    ['Vermieter', '#00b4d8', 'Kurze Frage wegen der Nebenkosten …'],
    ['Erinnerung', '#f5b400', 'Du wolltest heute produktiv sein.'],
    ['Kollegin', '#5b8cff', 'Wer hat die Mikrowelle so hinterlassen?'],
    ['Wetter', '#00b4d8', 'Es regnet. Aber nur bei dir.'],
    ['Spiele-App', '#ff5ca8', 'Deine Energie ist wieder voll! Weiterspielen?'],
    ['Mama', '#ff8a5b', 'Hast du schon gegessen?'],
    ['Sprachnachricht', '#3ddc84', 'Lisa hat dir 4:37 Minuten geschickt.']
  ];

  // {n} {k} {d} werden bei der Auswertung durch die Werte der Runde ersetzt
  var PROFILES = {
    laser: { name: 'Der Laser', quote: 'Nachrichten? Welche Nachrichten?',
      desc: 'Fokus-Score über 95. Wir haben extra nachgeprüft: Du bist nicht ablenkbar.' },
    kette: { name: 'Die Kette', quote: '{n} am Stück. Dann hat dich doch was erwischt.',
      desc: '{n} Punkte hintereinander, ohne Fehler und ohne einen zu verpassen.' },
    blitz: { name: 'Der Blitzableiter', quote: '{k} Kicks, {k} Abstürze.',
      desc: 'Jeder Blitz hat erst Punkte gebracht und dann mehr gekostet. Nächstes Mal: kein Kick, kein Absturz.' },
    hoernchen: { name: 'Das Eichhörnchen', quote: 'Du wolltest die Nachrichten nicht lesen. Hast du aber.',
      desc: '{n} Nachrichten erwischt. Die waren übrigens alle erfunden.' },
    glaeubig: { name: 'Der Leichtgläubige', quote: 'Du vertraust jedem Punkt. Auch den falschen.',
      desc: '{d} hohle Punkte erwischt. Die Fälschungen sehen echt aus, wir wissen.' },
    vorsicht: { name: 'Der Vorsichtige', quote: 'Kein einziger Fehler. Aber ganz schön viele Punkte liegen gelassen.',
      desc: 'Keine Nachricht, keine Fälschung, kein Blitz. Mit etwas mehr Mut geht die Kurve nach oben.' },
    sprinter: { name: 'Der Sprinter', quote: 'Zwanzig Sekunden Weltklasse. Dann kam die Push-Nachricht.',
      desc: 'Stark gestartet, hinten raus eingebrochen. Die Kurve sagt alles.' },
    spaet: { name: 'Der Spätzünder', quote: 'Langsam warm geworden. Aber dann.',
      desc: 'Holpriger Start, starkes Finale. Je lauter es wurde, desto besser warst du.' },
    achterbahn: { name: 'Die Achterbahn', quote: 'Hoch, runter, hoch. Wie dein Puls bei jeder Push-Nachricht.',
      desc: 'Deine Kurve springt von Abschnitt zu Abschnitt. Mal voll da, mal ganz weg.' },
    linie: { name: 'Die Linie', quote: 'Dich bringt nichts aus der Ruhe. Nicht mal deine Mutter.',
      desc: 'Von der ersten bis zur letzten Sekunde auf einem Niveau. Kein Kick, kein Absturz.' }
  };


  var CYAN = '#00faf5';
  var BLUE = '#2a6bff';
  var KICK = '#ff2e88';
  var BG = '#020713';
  var SCALE = [523.25, 587.33, 659.25, 783.99, 880, 1046.5, 1174.66, 1318.51, 1567.98];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function store(k, v) {
    try {
      if (v === undefined) return JSON.parse(localStorage.getItem('stoerfeuer.' + k));
      localStorage.setItem('stoerfeuer.' + k, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function mix(a, b, t) {
    var pa = parseInt(a.slice(1), 16), pb = parseInt(b.slice(1), 16);
    var r = Math.round(((pa >> 16) & 255) * (1 - t) + ((pb >> 16) & 255) * t);
    var g = Math.round(((pa >> 8) & 255) * (1 - t) + ((pb >> 8) & 255) * t);
    var bl = Math.round((pa & 255) * (1 - t) + (pb & 255) * t);
    return 'rgb(' + r + ',' + g + ',' + bl + ')';
  }

  function track(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('stoerfeuer_' + name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'stoerfeuer_' + name }, data)); } catch (e) {}
  }

  var BOLT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 2 4 13.5h6.5L9 22l10-12h-6.6z" fill="currentColor"/></svg>';

  function preis(v) { return v.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  // Produkte im Gutschein-Block: „Bestellen“ fuehrt per Warenkorb-Link direkt in den Checkout,
  // der Code ist dort schon angewendet (/cart/<variante>:1?discount=<code>).
  function produkteHtml(cfg) {
    var pz = parseFloat(String(cfg.rabatt).replace(',', '.')) || 0;
    return '<div class="sf-prods">' + cfg.produkte.map(function (p, i) {
      var url = cfg.shop + '/cart/' + encodeURIComponent(p.variante) + ':1?discount=' + encodeURIComponent(cfg.code);
      var neu = Math.round(p.preis * (100 - pz)) / 100;
      return '<div class="sf-prod' + (i === 0 ? ' sf-prod-top' : '') + '">' +
        '<img src="' + esc(p.bild) + '" alt="" loading="lazy">' +
        '<div class="sf-prod-info"><b>' + esc(p.titel) + '</b>' + (p.hinweis ? '<span>' + esc(p.hinweis) + '</span>' : '') +
          '<span class="sf-prod-price"><s>' + preis(p.preis) + '</s> <strong>' + preis(neu) + '</strong></span></div>' +
        '<a class="sf-btn sf-buy" data-produkt="' + esc(p.titel) + '" href="' + esc(url) + '">Bestellen</a>' +
      '</div>';
    }).join('') + '</div>';
  }

  var PRODUKTE = [
    { titel: 'Monatspackung · 116 Shots', hinweis: '2 Sprays', preis: 34.9, variante: '55626022715774',
      bild: 'https://cdn.shopify.com/s/files/1/0933/6409/3310/files/monatsvorrat1.png?v=1764341968&width=240' },
    { titel: 'Einzelpackung · 58 Shots', hinweis: '1 Spray zum Ausprobieren', preis: 19.9, variante: '55929011732862',
      bild: 'https://cdn.shopify.com/s/files/1/0933/6409/3310/files/einzelverpackung.jpg?v=1764341914&width=240' }
  ];

  function template(cfg) {
    var logo = cfg.logo ? '<img class="sf-logo" src="' + esc(cfg.logo) + '" alt="synapshot">' : '<div class="sf-wordmark">synapshot</div>';
    return '' +
      '<div class="sf-stage">' +
        '<div class="sf-shake"><canvas class="sf-canvas"></canvas><div class="sf-notes"></div></div>' +
        '<button type="button" class="sf-mute" aria-label="Ton aus" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path class="sf-wave" d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/><path class="sf-x" d="M16 9l6 6M22 9l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<div class="sf-hud" hidden>' +
          '<div class="sf-hud-l"><b class="sf-points">0</b><span>Punkte</span></div>' +
          '<div class="sf-hud-c"><span class="sf-dots"><i></i><i></i><i></i></span><b class="sf-phase">Sammeln</b><span class="sf-secs">60</span></div>' +
          '<div class="sf-hud-r"><b class="sf-combo">x1</b><span>Serie</span></div>' +
        '</div>' +
        '<div class="sf-banner" hidden><b></b><span></span></div>' +
        '<div class="sf-toast" hidden><i><svg viewBox="0 0 64 40" aria-hidden="true"><path d="M8 20h48" stroke="currentColor" stroke-width="2" stroke-dasharray="3 4" opacity=".5"/><circle class="sf-toast-dot" cx="14" cy="20" r="7" fill="currentColor"/></svg></i><b>Nicht tippen!</b><span>Finger auflegen und über den Bildschirm ziehen.</span></div>' +

        '<div class="sf-screen sf-start">' +
          '<div class="sf-panel">' + logo +
            '<h1 class="sf-title">Störfeuer</h1>' +
            '<p class="sf-lead">60 Sekunden volle Konzentration. Schaffst du das?</p>' +
            '<ul class="sf-rules">' +
              '<li><i class="sf-ico sf-ico-real"></i><span><b>Volle Punkte</b> mit dem Ring einsammeln. Je länger die Serie, desto mehr zählt’s.</span></li>' +
              '<li><i class="sf-ico sf-ico-decoy"></i><span><b>Hohle Punkte</b> und <b>Nachrichten</b> nicht berühren.</span></li>' +
              '<li><i class="sf-ico sf-ico-kick">' + BOLT + '</i><span><b>Blitze</b> geben einen Kick. Und dann den Absturz.</span></li>' +
            '</ul>' +
            '<button type="button" class="sf-btn sf-go">Los geht’s</button>' +
            '<div class="sf-meta"><button type="button" class="sf-sound" aria-pressed="false">Ton: aus</button><span class="sf-best"></span></div>' +
            '<p class="sf-reward">Wer durchhält, bekommt <b>' + esc(cfg.rabatt) + '</b> auf die erste Bestellung.</p>' +
            '<p class="sf-small">Bewegte Effekte, keine schnellen Blitze. Wer lichtempfindlich ist, spielt bitte mit Bedacht.</p>' +
          '</div>' +
        '</div>' +

        '<div class="sf-screen sf-count" hidden><b>3</b><span class="sf-count-hint"></span></div>' +

        '<div class="sf-screen sf-away" hidden><div class="sf-panel sf-panel-sm">' +
          '<h2 class="sf-h2">Erwischt.</h2><p class="sf-lead">Du warst kurz weg. Zählt als Ablenkung.</p>' +
          '<button type="button" class="sf-btn sf-resume">Weiter</button></div></div>' +

        '<div class="sf-screen sf-result" hidden><div class="sf-panel sf-panel-result">' + logo +
          // Erst das Angebot, dann das Ergebnis – damit den Gutschein jeder sieht
          '<h2 class="sf-done">Geschafft!<span>Hier ist dein Gutschein.</span></h2>' +
          '<div class="sf-code">' +
            (cfg.produktSlogan || cfg.claim ? '<p class="sf-claim">' + (cfg.produktSlogan ? '<span>' + esc(cfg.produktSlogan) + '</span>' : '') + esc(cfg.claim) + '</p>' : '') +
            '<p class="sf-code-head"><b class="sf-code-value">' + esc(cfg.rabatt) + '</b> auf deine erste Bestellung' +
              (cfg.gueltigBis ? '<small>Code gültig bis ' + esc(cfg.gueltigBis) + '</small>' : '') + '</p>' +
            produkteHtml(cfg) +
            '<div class="sf-code-row sf-code-row-sm"><span>Code</span><code>' + esc(cfg.code) + '</code><button type="button" class="sf-copy">Kopieren</button></div>' +
            '<a class="sf-redeem" href="' + esc(cfg.redeemUrl) + '">Erst umschauen: zum Shop, Code ist schon aktiv</a>' +
          '</div>' +
          '<button type="button" class="sf-to-result">Zu deinem Ergebnis ↓</button>' +
          '<p class="sf-kicker">Dein Fokus-Profil</p>' +
          '<h2 class="sf-profile"></h2>' +
          '<p class="sf-quote"></p>' +
          '<div class="sf-scorebox">' +
            '<div class="sf-score"><b>0</b><span>Fokus-Score</span></div>' +
            '<div class="sf-bars">' +
              '<div class="sf-bar sf-bar-t"><span>Treffsicherheit</span><i><u></u></i><b>0</b></div>' +
              '<div class="sf-bar sf-bar-k"><span>Konstanz</span><i><u></u></i><b>0</b></div>' +
            '</div>' +
          '</div>' +
          '<div class="sf-chart"><canvas></canvas><div class="sf-legend"><span class="sf-l-now">Diese Runde</span><span class="sf-l-ghost">Letzte Runde</span></div></div>' +
          '<p class="sf-desc"></p>' +
          '<ul class="sf-stats"></ul>' +
          '<p class="sf-slogan">' + esc(cfg.slogan) + '</p>' +
          '<div class="sf-actions"><button type="button" class="sf-btn sf-share">Teilen</button><button type="button" class="sf-btn sf-btn-ghost sf-again">Nochmal</button></div>' +
          (cfg.klaviyoForm || cfg.newsletterUrl ?
          '<div class="sf-optin">' +
            '<p class="sf-optin-h">Neue Runden und Angebote per Mail?</p>' +
            '<p class="sf-optin-p">Freiwillig. Dein Code oben gilt so oder so.</p>' +
            (cfg.klaviyoForm ? '<button type="button" class="sf-btn sf-btn-ghost sf-klaviyo">Zur Anmeldung</button>'
              : '<a href="' + esc(cfg.newsletterUrl) + '" target="_blank" rel="noopener" class="sf-btn sf-btn-ghost sf-newsletter-link">Zur Anmeldung</a>') +
          '</div>' : '') +
        '</div></div>' +
      '</div>';
  }

  function mount(root) {
    if (root.__stoerfeuer) return;
    root.__stoerfeuer = true;
    var d = root.dataset;
    var cfg = {
      code: d.code || 'STOERFEUER10',
      redirect: d.redirect || '/products/2er-pack',
      shop: (d.shop || '').replace(/\/$/, ''),
      logo: d.logo || '',
      shareUrl: d.shareUrl || 'synapshot.com/pages/stoerfeuer',
      rabatt: d.rabatt || '10 %',
      slogan: d.slogan || 'Train your brain.',
      // Ein bewusst leer gelassenes Feld bleibt leer; nur ein fehlendes Attribut nimmt den Standard
      produktSlogan: d.produktSlogan !== undefined ? d.produktSlogan : 'Optimize your brain.',
      claim: d.claim !== undefined ? d.claim : 'Synapshot mit Aminosäuren. Kein Kick, kein Absturz.',
      gueltigBis: d.gueltigBis || '',
      klaviyoForm: d.klaviyoForm || '',
      newsletterUrl: d.newsletterUrl !== undefined ? d.newsletterUrl : '/pages/stoerfeuer-newsletter',
      produkte: PRODUKTE
    };
    try { var pj = d.produkte && JSON.parse(d.produkte); if (pj && pj.length) cfg.produkte = pj.filter(function (p) { return p && p.variante; }); } catch (e) {}
    cfg.redeemUrl = cfg.shop + '/discount/' + encodeURIComponent(cfg.code) + '?redirect=' + encodeURIComponent(cfg.redirect);
    var record = /sf-record/.test(location.hash);
    var autoplay = record || /sf-autoplay/.test(location.hash);
    var botOpts = { kick: false, note: false };
    var speed = (location.hash.match(/sf-speed=(\d+)/) || [])[1] * 1 || 1;

    root.classList.add('sf');
    root.innerHTML = template(cfg);
    var q = function (s) { return root.querySelector(s); };
    var stage = q('.sf-stage'), shakeEl = q('.sf-shake'), canvas = q('.sf-canvas'), ctx = canvas.getContext('2d');
    var notesEl = q('.sf-notes'), hud = q('.sf-hud'), banner = q('.sf-banner');
    var elPoints = q('.sf-points'), elCombo = q('.sf-combo'), elPhase = q('.sf-phase'), elSecs = q('.sf-secs');
    var scrStart = q('.sf-start'), scrCount = q('.sf-count'), scrAway = q('.sf-away'), scrResult = q('.sf-result');
    var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;

    var logoImg = null;
    if (cfg.logo) { logoImg = new Image(); logoImg.crossOrigin = 'anonymous'; logoImg.src = cfg.logo; }

    /* ---------- Ton ---------- */
    var savedTon = store('ton');
    var audio = { on: savedTon === null || savedTon === undefined ? true : !!savedTon, ctx: null };
    function audioCtx() {
      if (!audio.ctx) { var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; audio.ctx = new AC(); }
      if (audio.ctx.state === 'suspended') audio.ctx.resume();
      return audio.ctx;
    }
    function tone(f, dur, type, vol, to, delay) {
      if (!audio.on) return;
      var c = audioCtx(); if (!c) return;
      var t0 = c.currentTime + (delay || 0);
      var o = c.createOscillator(), g = c.createGain();
      o.type = type || 'sine';
      o.frequency.setValueAtTime(f, t0);
      if (to) o.frequency.exponentialRampToValueAtTime(to, t0 + dur);
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(vol || 0.08, t0 + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
      o.connect(g); g.connect(c.destination);
      o.start(t0); o.stop(t0 + dur + 0.02);
    }
    function buzz(ms) { if (navigator.vibrate) { try { navigator.vibrate(ms); } catch (e) {} } }
    var soundBtn = q('.sf-sound');
    var muteBtn = q('.sf-mute');
    function paintSound() {
      soundBtn.textContent = 'Ton: ' + (audio.on ? 'an' : 'aus'); soundBtn.setAttribute('aria-pressed', audio.on);
      muteBtn.classList.toggle('is-off', !audio.on); muteBtn.setAttribute('aria-label', audio.on ? 'Ton aus' : 'Ton an');
    }
    function toggleSound() {
      audio.on = !audio.on; store('ton', audio.on); paintSound();
      if (audio.on) { tone(880, 0.12, 'sine', 0.06); tone(1318.5, 0.16, 'sine', 0.05, null, 0.08); }
    }
    soundBtn.addEventListener('click', toggleSound);
    muteBtn.addEventListener('click', toggleSound);
    muteBtn.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    paintSound();

    /* ---------- Größe ---------- */
    var W = 0, H = 0, DPR = 1, U = 1, R = 26, SR = 11, sprites = {}, bgLayer = null;
    function resize() {
      var r = stage.getBoundingClientRect();
      W = Math.max(280, r.width); H = Math.max(360, r.height);
      DPR = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(W * DPR); canvas.height = Math.round(H * DPR);
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      U = clamp(Math.min(W, H) / 420, 0.8, 1.35);
      R = 27 * U; SR = 11 * U;
      makeSprites(); makeBg();
      if (ring.x === 0) { ring.x = W / 2; ring.y = H * 0.55; }
      ring.x = clamp(ring.x, R, W - R); ring.y = clamp(ring.y, R, H - R);
    }
    function sprite(size, draw) {
      var c = document.createElement('canvas'); c.width = c.height = Math.ceil(size * DPR);
      var g = c.getContext('2d'); g.scale(DPR, DPR); draw(g, size / 2); return { c: c, s: size };
    }
    function makeSprites() {
      var s = SR * 5;
      sprites.real = sprite(s, function (g, m) {
        var gr = g.createRadialGradient(m, m, 0, m, m, m);
        gr.addColorStop(0, 'rgba(0,250,245,0.55)'); gr.addColorStop(0.35, 'rgba(0,250,245,0.18)'); gr.addColorStop(1, 'rgba(0,250,245,0)');
        g.fillStyle = gr; g.fillRect(0, 0, m * 2, m * 2);
        g.beginPath(); g.arc(m, m, SR, 0, 7); g.fillStyle = CYAN; g.fill();
        g.beginPath(); g.arc(m - SR * 0.3, m - SR * 0.3, SR * 0.35, 0, 7); g.fillStyle = 'rgba(255,255,255,0.75)'; g.fill();
      });
      sprites.decoy = sprite(s, function (g, m) {
        var gr = g.createRadialGradient(m, m, 0, m, m, m);
        gr.addColorStop(0, 'rgba(0,250,245,0.22)'); gr.addColorStop(1, 'rgba(0,250,245,0)');
        g.fillStyle = gr; g.fillRect(0, 0, m * 2, m * 2);
        g.beginPath(); g.arc(m, m, SR - 1.4 * U, 0, 7); g.lineWidth = 2.8 * U; g.strokeStyle = CYAN; g.stroke();
        g.beginPath(); g.arc(m, m, SR * 0.28, 0, 7); g.fillStyle = CYAN; g.fill();
      });
      sprites.kick = sprite(SR * 6, function (g, m) {
        var gr = g.createRadialGradient(m, m, 0, m, m, m);
        gr.addColorStop(0, 'rgba(255,46,136,0.6)'); gr.addColorStop(0.4, 'rgba(255,46,136,0.2)'); gr.addColorStop(1, 'rgba(255,46,136,0)');
        g.fillStyle = gr; g.fillRect(0, 0, m * 2, m * 2);
        var k = SR * 1.7 / 12;
        g.save(); g.translate(m - 12 * k, m - 12 * k); g.scale(k, k);
        g.beginPath(); g.moveTo(13.5, 2); g.lineTo(4, 13.5); g.lineTo(10.5, 13.5); g.lineTo(9, 22); g.lineTo(19, 10); g.lineTo(12.4, 10); g.closePath();
        g.fillStyle = '#fff'; g.fill(); g.lineWidth = 1.6; g.strokeStyle = KICK; g.stroke();
        g.restore();
      });
    }
    function makeBg() {
      bgLayer = document.createElement('canvas'); bgLayer.width = canvas.width; bgLayer.height = canvas.height;
      var g = bgLayer.getContext('2d'); g.scale(DPR, DPR);
      g.fillStyle = BG; g.fillRect(0, 0, W, H);
      var gr = g.createRadialGradient(W * 0.5, H * 0.35, 0, W * 0.5, H * 0.35, Math.max(W, H) * 0.75);
      gr.addColorStop(0, 'rgba(0,120,160,0.20)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      g.fillStyle = gr; g.fillRect(0, 0, W, H);
      g.strokeStyle = 'rgba(0,250,245,0.045)'; g.lineWidth = 1;
      var step = 36 * U;
      g.beginPath();
      for (var x = (W % step) / 2; x < W; x += step) { g.moveTo(x + 0.5, 0); g.lineTo(x + 0.5, H); }
      for (var y = (H % step) / 2; y < H; y += step) { g.moveTo(0, y + 0.5); g.lineTo(W, y + 0.5); }
      g.stroke();
    }

    /* ---------- Zustand ---------- */
    var ring = { x: 0, y: 0, vx: 0, vy: 0, rot: 0, a1: rnd(0, 9), a2: rnd(0, 9), a3: rnd(0, 9), a4: rnd(0, 9) };
    var input = { type: coarse ? 'touch' : 'mouse', down: false, has: false, px: 0, py: 0, lx: 0, ly: 0, id: null };
    var S;
    function fresh(mode) {
      S = {
        mode: mode, t: 0, phase: -1, banner: 0, points: 0, shown: 0, streak: 0, combo: 1, lastHit: 0,
        stun: 0, crash: 0, crashFlag: false, shake: 0, glitch: 0, glitchT: 2,
        syn: [], notes: [], parts: [], floats: [], net: [], line: [], q: 0.6, sample: 0,
        timers: { real: 0.2, decoy: 0.6, kick: 1.5, note: 1.2 },
        buckets: [], ph: [{ h: 0, m: 0, e: 0 }, { h: 0, m: 0, e: 0 }, { h: 0, m: 0, e: 0 }],
        n: { hits: 0, misses: 0, decoys: 0, notes: 0, kicks: 0, away: 0, best: 0, run: 0 },
        deck: shuffle(NOTES.slice()), teaser: false
      };
      for (var i = 0; i < 12; i++) S.buckets.push({ h: 0, m: 0, e: 0 });
      notesEl.innerHTML = '';
    }
    fresh('idle');

    /* ---------- Eingabe ---------- */
    function local(e) { var r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    canvas.addEventListener('pointerdown', function (e) {
      input.type = e.pointerType === 'mouse' ? 'mouse' : 'touch';
      input.down = true; input.id = e.pointerId; input.lx = e.clientX; input.ly = e.clientY; input.t0 = performance.now(); input.sx = e.clientX; input.sy = e.clientY;
      var p = local(e); input.px = p.x; input.py = p.y; input.has = true;
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      if (S.mode === 'play') e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') {
        input.type = 'mouse'; var p = local(e); input.px = p.x; input.py = p.y; input.has = true; return;
      }
      if (!input.down || e.pointerId !== input.id) return;
      // Touch: der Ring sitzt direkt unter dem Finger
      var q2 = local(e); input.px = q2.x; input.py = q2.y; input.has = true;
      if (toastOn && Math.hypot(e.clientX - input.sx, e.clientY - input.sy) > 60) hideToast();
      e.preventDefault();
    }, { passive: false });
    // Wer nur tippt statt zu ziehen, bekommt einen Hinweis
    var taps = [], toastOn = false, toastTimer = null, toastEl = q('.sf-toast');
    function hideToast() { toastOn = false; toastEl.classList.remove('is-on'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.hidden = true; }, 250); }
    function showToast() {
      toastOn = true; clearTimeout(toastTimer); toastEl.hidden = false; void toastEl.offsetWidth; toastEl.classList.add('is-on');
      toastTimer = setTimeout(hideToast, 2800); buzz(30); track('tipp_hinweis');
    }
    function up(e) {
      if (e.pointerId !== input.id) return;
      input.down = false;
      if (e.pointerType === 'mouse' || S.mode !== 'play' || S.banner > 0) return;
      var now = performance.now();
      if (now - input.t0 < 300 && Math.hypot(e.clientX - input.sx, e.clientY - input.sy) < 14) {
        taps.push(now); taps = taps.filter(function (t) { return now - t < 4000; });
        if (taps.length >= 3 && !toastOn) { taps = []; showToast(); }
      }
    }
    canvas.addEventListener('pointerup', up);
    canvas.addEventListener('pointercancel', up);
    canvas.addEventListener('touchmove', function (e) { if (S.mode === 'play') e.preventDefault(); }, { passive: false });

    /* ---------- Spawning ---------- */
    var TOP = 64, BOTTOM = 70;
    function freeSpot(minD) {
      var x, y;
      for (var i = 0; i < 24; i++) {
        x = rnd(SR * 2 + 8, W - SR * 2 - 8); y = rnd(TOP + SR * 2, H - BOTTOM - SR * 2);
        if (Math.hypot(x - ring.x, y - ring.y) < minD) continue;
        var ok = true;
        for (var j = 0; j < S.syn.length; j++) if (Math.hypot(x - S.syn[j].x, y - S.syn[j].y) < SR * 3.2) { ok = false; break; }
        if (ok) break;
      }
      return { x: x, y: y };
    }
    function count(kind) { var n = 0; for (var i = 0; i < S.syn.length; i++) if (S.syn[i].kind === kind) n++; return n; }
    function spawn(kind, P) {
      var p = freeSpot(kind === 'real' ? R * 2.6 : R * 3.4);
      var a = rnd(0, 6.283), sp = P ? P.move * U : 0;
      S.syn.push({ kind: kind, x: p.x, y: p.y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, age: 0,
        life: kind === 'kick' ? 3.2 : kind === 'decoy' ? (P ? P.life + 0.6 : 3) : (P ? P.life : 2.4), wob: rnd(0, 6) });
    }
    function spawnNote(P) {
      var data = S.deck.pop(); if (!S.deck.length) S.deck = shuffle(NOTES.slice());
      var el = document.createElement('div');
      el.className = 'sf-note';
      el.innerHTML = '<div class="sf-note-ico" style="background:' + data[1] + '">' + esc(data[0].charAt(0)) + '</div>' +
        '<div class="sf-note-body"><div class="sf-note-head"><b>' + esc(data[0]) + '</b><span>jetzt</span></div><p>' + esc(data[2]) + '</p></div>' +
        '<em class="sf-note-read">Gelesen</em>';
      // Auf schmalen Bildschirmen schmaler, damit man am Rand vorbeikommt
      var w = W < 600 ? Math.round(W * 0.62) : 330;
      el.style.width = w + 'px';
      notesEl.appendChild(el);
      var h = el.offsetHeight || 64;
      var x, y, tries = 0;
      do {
        x = rnd(16, W - w - 16); y = rnd(TOP + 6, H - BOTTOM - h - 10); tries++;
      } while (tries < 30 && (rectDist(ring.x, ring.y, x, y, w, h) < R + 70 * U || S.notes.some(function (o) { return Math.abs(o.y - y) < h + 12 && Math.abs(o.x - x) < w; })));
      var fromSide = Math.random() < 0.35;
      S.notes.push({ el: el, x: x, y: y, w: w, h: h, sx: fromSide ? (Math.random() < 0.5 ? -w - 20 : W + 20) : x, sy: fromSide ? y : -h - 20,
        vx: rnd(-14, 14) * U, vy: rnd(-6, 6) * U, age: 0, life: (P ? (P.note > 3 ? 3.8 : 3.1) : 3.6), hit: false });
      tone(1318.5, 0.07, 'sine', 0.035); tone(1760, 0.09, 'sine', 0.03, null, 0.09);
    }
    function rectDist(cx, cy, x, y, w, h) {
      var nx = clamp(cx, x, x + w), ny = clamp(cy, y, y + h);
      return Math.hypot(cx - nx, cy - ny);
    }

    /* ---------- Effekte ---------- */
    function burst(x, y, color, n, spd) {
      for (var i = 0; i < n; i++) {
        var a = rnd(0, 6.283), v = rnd(0.3, 1) * (spd || 180) * U;
        S.parts.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: rnd(0.35, 0.7), age: 0, c: color, s: rnd(1.2, 3) * U });
      }
      if (S.parts.length > 320) S.parts.splice(0, S.parts.length - 320);
    }
    function float(x, y, text, color, big) { S.floats.push({ x: x, y: y, text: text, c: color, age: 0, big: !!big }); }
    function shake(v) { S.shake = Math.max(S.shake, reduced ? v * 0.3 : v); }

    function addPoints(v) { S.points = Math.max(0, S.points + v); }
    function bucket() { return S.buckets[clamp(Math.floor(S.t / 5), 0, 11)]; }
    function stat(k) { bucket()[k]++; if (S.phase >= 0) S.ph[S.phase][k]++; }
    function quality(v, k) { S.q += (v - S.q) * k; }

    function hit(s) {
      S.streak++; S.combo = Math.min(5, 1 + Math.floor(S.streak / 4)); S.lastHit = S.t;
      var pts = 10 * S.combo; addPoints(pts); S.n.hits++; S.n.run++; S.n.best = Math.max(S.n.best, S.n.run);
      stat('h'); quality(1, 0.16);
      burst(s.x, s.y, CYAN, 12 + S.combo * 3, 160 + S.combo * 30);
      float(s.x, s.y - SR * 1.5, '+' + pts, CYAN, S.combo >= 4);
      S.net.push({ x: s.x, y: s.y, t: S.t }); if (S.net.length > 180) S.net.shift();
      tone(SCALE[Math.min(SCALE.length - 1, S.combo - 1 + (S.streak % 4))], 0.16, 'triangle', 0.07);
      if (S.streak > 0 && S.streak % 4 === 0 && S.combo > 1) { tone(SCALE[Math.min(8, S.combo + 3)], 0.22, 'sine', 0.05, null, 0.06); float(ring.x, ring.y - R * 1.8, 'Serie x' + S.combo, '#ffffff', true); }
    }
    function breakStreak() { S.streak = 0; S.combo = 1; S.n.run = 0; }
    function fake(s) {
      breakStreak(); addPoints(-25); S.n.decoys++; stat('e'); quality(0, 0.3);
      burst(s.x, s.y, KICK, 16, 200); float(s.x, s.y - SR * 1.5, '−25 Fälschung', KICK);
      shake(8); buzz(40); tone(150, 0.2, 'square', 0.06, 70);
    }
    function kick(s) {
      breakStreak(); addPoints(100); S.n.kicks++; stat('e'); quality(0, 0.25);
      S.crash = 3.4; S.crashFlag = false;
      burst(s.x, s.y, KICK, 30, 320); float(s.x, s.y - SR * 2, 'KICK +100', KICK, true);
      shake(12); buzz([30, 40, 30]); tone(260, 0.28, 'sawtooth', 0.06, 1500);
    }
    function noteHit(n) {
      n.hit = true; n.el.classList.add('is-read');
      breakStreak(); addPoints(-30); S.n.notes++; stat('e'); quality(0, 0.35);
      S.stun = 0.6; float(ring.x, ring.y - R * 1.6, '−30 Abgelenkt', KICK);
      shake(9); buzz(60); tone(230, 0.28, 'sawtooth', 0.05, 110);
      setTimeout(function () { n.age = Math.max(n.age, n.life - 0.25); }, 450);
    }
    function miss(s) {
      S.n.run = 0;
      S.streak = Math.max(0, S.streak - 4); S.combo = Math.min(5, 1 + Math.floor(S.streak / 4));
      S.n.misses++; stat('m'); quality(0, 0.2);
      burst(s.x, s.y, 'rgba(219,234,254,0.6)', 5, 60);
    }

    /* ---------- Ablauf ---------- */
    function show(el, on) { el.hidden = !on; }
    function startCountdown() {
      track(S.mode === 'over' ? 'nochmal' : 'start');
      fresh('count');
      show(scrStart, false); show(scrResult, false); show(hud, true); show(muteBtn, true);
      ring.x = W / 2; ring.y = H * 0.55; ring.vx = ring.vy = 0;
      if (input.type === 'mouse') { input.px = ring.x; input.py = ring.y; input.has = false; }
      paintHud();
      var n = 3, b = scrCount.querySelector('b');
      scrCount.querySelector('.sf-count-hint').textContent = input.type === 'mouse' ? 'Der Ring folgt deiner Maus.' : 'Finger auflegen und ziehen – nicht tippen.';
      show(scrCount, true); b.textContent = n; tone(660, 0.12, 'sine', 0.06);
      var iv = setInterval(function () {
        n--;
        if (n > 0) { b.textContent = n; b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; tone(660, 0.12, 'sine', 0.06); return; }
        clearInterval(iv); show(scrCount, false);
        tone(990, 0.2, 'sine', 0.07);
        S.mode = 'play'; S.t = 0; setPhase(0);
      }, autoplay ? 250 : 750);
    }
    function setPhase(i) {
      S.phase = i;
      var P = PHASES[i];
      banner.querySelector('b').textContent = P.title;
      banner.querySelector('span').textContent = P.sub;
      show(banner, true); banner.classList.remove('is-on'); void banner.offsetWidth; banner.classList.add('is-on');
      S.banner = i === 0 ? 1.4 : 1.8;
      var dots = hud.querySelectorAll('.sf-dots i');
      for (var k = 0; k < dots.length; k++) dots[k].className = k < i ? 'done' : k === i ? 'on' : '';
      elPhase.textContent = P.name;
      if (i > 0) { tone(523.25, 0.14, 'sine', 0.06); tone(783.99, 0.2, 'sine', 0.06, null, 0.12); track('phase', { phase: i + 1 }); }
      if (i === 2) S.timers.kick = 1.2;
    }
    function paintHud() {
      elPoints.textContent = Math.round(S.shown);
      elPoints.classList.toggle('is-crash', S.crash > 0);
      elCombo.textContent = 'x' + S.combo;
      elCombo.parentNode.classList.toggle('is-hot', S.combo >= 3);
      elSecs.textContent = Math.max(0, Math.ceil(ROUND - S.t));
    }

    function update(dt) {
      if (S.mode === 'idle') return idle(dt);
      updateFx(dt);
      if (S.mode !== 'play') return;
      if (S.banner > 0) {
        S.banner -= dt;
        if (S.banner <= 0) { banner.classList.remove('is-on'); show(banner, false); }
        S.shown += (S.points - S.shown) * Math.min(1, dt * 10); paintHud();
        return;
      }
      S.t += dt;
      var ph = S.t < 20 ? 0 : S.t < 40 ? 1 : 2;
      if (ph !== S.phase) { setPhase(ph); return; }
      if (S.t >= ROUND) return finish();
      var P = PHASES[S.phase];

      // Drift: der Ring will weg
      var t = S.t, dr = P.drift * 120 * U;
      var fx = (Math.sin(t * 0.73 + ring.a1) + 0.6 * Math.sin(t * 1.41 + ring.a2)) * dr;
      var fy = (Math.sin(t * 0.61 + ring.a3) + 0.6 * Math.sin(t * 1.27 + ring.a4)) * dr;
      if (S.crash > 0) { fx += Math.sin(t * 9) * 260 * U; fy += Math.cos(t * 7.3) * 260 * U; }
      if (autoplay) { bot(dt); }
      else if (input.has && (input.type === 'mouse' || input.down)) {
        var k = S.crash > 0 ? 4 : input.type === 'mouse' ? 11 : 16;
        var dvx = (input.px - ring.x) * k, dvy = (input.py - ring.y) * k;
        ring.vx += (dvx - ring.vx) * Math.min(1, dt * 9) + fx * dt;
        ring.vy += (dvy - ring.vy) * Math.min(1, dt * 9) + fy * dt;
      } else {
        ring.vx += fx * dt; ring.vy += fy * dt;
        var damp = Math.exp(-dt * (input.down ? 5 : 1.4));
        ring.vx *= damp; ring.vy *= damp;
        var sp = Math.hypot(ring.vx, ring.vy), cap = 170 * U;
        if (sp > cap) { ring.vx *= cap / sp; ring.vy *= cap / sp; }
      }
      ring.x += ring.vx * dt; ring.y += ring.vy * dt;
      if (ring.x < R) { ring.x = R; ring.vx = Math.abs(ring.vx) * 0.4; }
      if (ring.x > W - R) { ring.x = W - R; ring.vx = -Math.abs(ring.vx) * 0.4; }
      if (ring.y < TOP - 10 + R) { ring.y = TOP - 10 + R; ring.vy = Math.abs(ring.vy) * 0.4; }
      if (ring.y > H - BOTTOM + 10 - R) { ring.y = H - BOTTOM + 10 - R; ring.vy = -Math.abs(ring.vy) * 0.4; }

      if (S.stun > 0) S.stun -= dt;
      if (S.crash > 0) {
        S.crash -= dt;
        if (S.crash < 2.9 && !S.crashFlag) { S.crashFlag = true; float(ring.x, ring.y + R * 2, 'ABSTURZ', KICK, true); tone(900, 1.4, 'triangle', 0.05, 70); }
        if (S.crash < 2.9) addPoints(-69 * dt);
        if (S.crash <= 0) { float(ring.x, ring.y - R * 1.8, 'Kick-Bilanz −100', KICK, true); }
      }

      // Spawns
      var T = S.timers;
      T.real -= dt; if (T.real <= 0) { T.real = P.real * rnd(0.8, 1.2); if (count('real') < 4) spawn('real', P); }
      if (P.decoy) { T.decoy -= dt; if (T.decoy <= 0) { T.decoy = P.decoy * rnd(0.8, 1.25); if (count('decoy') < 4) spawn('decoy', P); } }
      if (P.kick) { T.kick -= dt; if (T.kick <= 0) { T.kick = P.kick * rnd(0.8, 1.2); if (count('kick') < 1) spawn('kick', P); } }
      if (P.note) { T.note -= dt; if (T.note <= 0) { T.note = P.note * rnd(0.75, 1.2); spawnNote(P); } }
      if (S.phase === 0 && !S.teaser && S.t > 13) { S.teaser = true; spawnNote(null); }

      // Punkte
      var canTouch = S.stun <= 0 && S.crash <= 0;
      for (var i = S.syn.length - 1; i >= 0; i--) {
        var s = S.syn[i];
        s.age += dt; s.x += s.vx * dt; s.y += s.vy * dt;
        if (s.x < SR * 2 || s.x > W - SR * 2) s.vx *= -1;
        if (s.y < TOP + SR || s.y > H - BOTTOM - SR) s.vy *= -1;
        if (s.age >= s.life) { S.syn.splice(i, 1); if (s.kind === 'real') miss(s); continue; }
        if (canTouch && s.age > 0.12 && Math.hypot(s.x - ring.x, s.y - ring.y) < R * 0.85 + SR) {
          S.syn.splice(i, 1);
          if (s.kind === 'real') hit(s); else if (s.kind === 'decoy') fake(s); else kick(s);
        }
      }
      // Nachrichten
      for (i = S.notes.length - 1; i >= 0; i--) {
        var n = S.notes[i];
        n.age += dt;
        if (n.age < 0.35) {
          var e = 1 - Math.pow(1 - n.age / 0.35, 3);
          n.cx = n.sx + (n.x - n.sx) * e; n.cy = n.sy + (n.y - n.sy) * e;
        } else { n.x += n.vx * dt; n.y += n.vy * dt; n.cx = n.x; n.cy = n.y; }
        n.el.style.transform = 'translate3d(' + n.cx.toFixed(1) + 'px,' + n.cy.toFixed(1) + 'px,0)';
        if (n.age > n.life - 0.25 && !n.out) { n.out = true; n.el.classList.add('is-out'); }
        if (n.age >= n.life) { n.el.remove(); S.notes.splice(i, 1); continue; }
        if (!n.hit && !n.out && n.age > 0.3 && S.stun <= 0 && rectDist(ring.x, ring.y, n.cx, n.cy, n.w, n.h) < R * 0.7) noteHit(n);
      }
      // Serie verfällt langsam
      if (S.streak > 0 && S.t - S.lastHit > 2.4) { S.streak = Math.max(0, S.streak - 4); S.combo = Math.min(5, 1 + Math.floor(S.streak / 4)); S.lastHit = S.t; }
      // Linie
      S.sample += dt;
      while (S.sample >= 0.25) { S.sample -= 0.25; S.line.push(S.q); }
      // Glitch in Phase 3
      if (S.phase === 2) { S.glitchT -= dt; if (S.glitchT <= 0) { S.glitchT = rnd(1.2, 2.4); S.glitch = 0.14; } }

      S.shown += (S.points - S.shown) * Math.min(1, dt * 10);
      paintHud();
    }
    function updateFx(dt) {
      ring.rot += dt * (0.5 + (S.combo - 1) * 0.45 + (S.crash > 0 ? 3 : 0));
      for (var i = S.parts.length - 1; i >= 0; i--) {
        var p = S.parts[i]; p.age += dt;
        if (p.age >= p.life) { S.parts.splice(i, 1); continue; }
        p.x += p.vx * dt; p.y += p.vy * dt; p.vx *= Math.exp(-dt * 3); p.vy *= Math.exp(-dt * 3);
      }
      for (i = S.floats.length - 1; i >= 0; i--) { S.floats[i].age += dt; if (S.floats[i].age > 1) S.floats.splice(i, 1); }
      S.shake *= Math.exp(-dt * 9); if (S.shake < 0.2) S.shake = 0;
      if (S.glitch > 0) S.glitch -= dt;
      var sx = S.shake ? rnd(-1, 1) * S.shake : 0, sy = S.shake ? rnd(-1, 1) * S.shake : 0;
      shakeEl.style.transform = S.shake ? 'translate3d(' + sx.toFixed(1) + 'px,' + sy.toFixed(1) + 'px,0)' : '';
    }
    // Attract-Modus: der Ring spielt selbst
    function idle(dt) {
      updateFx(dt);
      S.t += dt;
      S.timers.real -= dt;
      if (S.timers.real <= 0) { S.timers.real = 0.55; if (count('real') < 4) spawn('real', null); }
      bot(dt);
      ring.x += ring.vx * dt; ring.y += ring.vy * dt;
      ring.x = clamp(ring.x, R, W - R); ring.y = clamp(ring.y, R, H - R);
      for (var i = S.syn.length - 1; i >= 0; i--) {
        var s = S.syn[i]; s.age += dt;
        if (s.age >= s.life) { S.syn.splice(i, 1); continue; }
        if (Math.hypot(s.x - ring.x, s.y - ring.y) < R * 0.85 + SR) {
          S.syn.splice(i, 1); burst(s.x, s.y, CYAN, 10, 150);
          S.net.push({ x: s.x, y: s.y, t: S.t }); if (S.net.length > 40) S.net.shift();
        }
      }
    }
    function bot(dt) {
      var best = null, bd = 1e9;
      for (var i = 0; i < S.syn.length; i++) {
        var s = S.syn[i]; if (s.kind !== 'real') continue;
        var dd = Math.hypot(s.x - ring.x, s.y - ring.y); if (dd < bd) { bd = dd; best = s; }
      }
      var tx = best ? best.x : W / 2, ty = best ? best.y : H / 2;
      // Aufnahmemodus: gezielt einen Blitz oder eine Nachricht ansteuern
      var lure = null;
      if (botOpts.kick) for (i = 0; i < S.syn.length; i++) if (S.syn[i].kind === 'kick') lure = S.syn[i];
      if (botOpts.note && S.notes.length && !S.notes[0].hit) lure = { x: S.notes[0].cx + S.notes[0].w / 2, y: S.notes[0].cy + S.notes[0].h / 2, kind: 'note' };
      if (lure) { tx = lure.x; ty = lure.y; }
      // Hindernissen ausweichen
      var ax = (tx - ring.x) * 5, ay = (ty - ring.y) * 5;
      for (i = 0; i < S.syn.length; i++) {
        var o = S.syn[i]; if (o.kind === 'real' || o === lure) continue;
        var dx = ring.x - o.x, dy = ring.y - o.y, d2 = Math.hypot(dx, dy);
        if (d2 < R * 3) { ax += dx / d2 * 900; ay += dy / d2 * 900; }
      }
      for (i = 0; i < S.notes.length; i++) {
        if (lure && lure.kind === 'note' && i === 0) continue;
        var n = S.notes[i]; var cx = clamp(ring.x, n.cx, n.cx + n.w), cy = clamp(ring.y, n.cy, n.cy + n.h);
        var ex = ring.x - cx, ey = ring.y - cy, dn = Math.hypot(ex, ey) || 1;
        if (dn < R * 2.2) { ax += ex / dn * 1400; ay += ey / dn * 1400; }
      }
      var sp = Math.hypot(ax, ay), cap = (botOpts.cap || 260) * U;
      if (sp > cap) { ax *= cap / sp; ay *= cap / sp; }
      ring.vx += (ax - ring.vx) * Math.min(1, dt * 6);
      ring.vy += (ay - ring.vy) * Math.min(1, dt * 6);
    }

    /* ---------- Zeichnen ---------- */
    function render() {
      var g = ctx;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.drawImage(bgLayer, 0, 0);
      g.setTransform(DPR, 0, 0, DPR, 0, 0);
      var playing = S.mode === 'play' || S.mode === 'over';
      if (S.crash > 0) { g.fillStyle = 'rgba(255,46,136,' + (0.05 + 0.04 * Math.sin(S.t * 5)).toFixed(3) + ')'; g.fillRect(0, 0, W, H); }

      // Netzwerk der gesammelten Synapsen
      var net = S.net;
      if (net.length > 1) {
        g.lineWidth = 1.2 * U;
        for (var i = 1; i < net.length; i++) {
          var fresh = clamp(1 - (S.t - net[i].t) / 1.2, 0, 1);
          g.strokeStyle = 'rgba(0,250,245,' + (0.10 + 0.5 * fresh).toFixed(3) + ')';
          g.beginPath(); g.moveTo(net[i - 1].x, net[i - 1].y); g.lineTo(net[i].x, net[i].y); g.stroke();
        }
        g.fillStyle = 'rgba(0,250,245,0.45)';
        for (i = 0; i < net.length; i++) { g.beginPath(); g.arc(net[i].x, net[i].y, 1.8 * U, 0, 7); g.fill(); }
      }

      // Punkte
      for (i = 0; i < S.syn.length; i++) {
        var s = S.syn[i], sp = sprites[s.kind];
        var pop = s.age < 0.18 ? easeBack(s.age / 0.18) : 1;
        var fade = s.life - s.age < 0.3 ? (s.life - s.age) / 0.3 : 1;
        var pulse = s.kind === 'kick' ? 1 + 0.08 * Math.sin(s.age * 9) : 1 + 0.04 * Math.sin(s.age * 4 + s.wob);
        var sz = sp.s * pop * pulse;
        g.globalAlpha = clamp(fade, 0, 1);
        g.drawImage(sp.c, s.x - sz / 2, s.y - sz / 2, sz, sz);
        if (s.kind === 'real' && playing) {
          var left = 1 - s.age / s.life;
          g.beginPath(); g.arc(s.x, s.y, SR + 5 * U, -Math.PI / 2, -Math.PI / 2 + left * 6.283);
          g.strokeStyle = 'rgba(0,250,245,0.55)'; g.lineWidth = 1.6 * U; g.stroke();
        }
        g.globalAlpha = 1;
      }

      // Partikel
      g.globalCompositeOperation = 'lighter';
      for (i = 0; i < S.parts.length; i++) {
        var p = S.parts[i], a = 1 - p.age / p.life;
        g.globalAlpha = a; g.fillStyle = p.c;
        g.beginPath(); g.arc(p.x, p.y, p.s * (0.5 + a), 0, 7); g.fill();
      }
      g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';

      drawRing(g);

      // Schwebende Texte
      for (i = 0; i < S.floats.length; i++) {
        var f = S.floats[i], k = f.age;
        g.globalAlpha = clamp(1.4 - k * 1.4, 0, 1);
        var size = (f.big ? 26 : 17) * U * (k < 0.12 ? 0.6 + k / 0.12 * 0.4 : 1);
        g.font = '700 ' + size.toFixed(1) + 'px Syne, "Arial Black", sans-serif';
        g.textAlign = 'center'; g.textBaseline = 'middle';
        g.lineWidth = 4 * U; g.strokeStyle = 'rgba(2,7,19,0.85)';
        var fy = f.y - k * 46 * U;
        g.strokeText(f.text, f.x, fy); g.fillStyle = f.c; g.fillText(f.text, f.x, fy);
      }
      g.globalAlpha = 1;

      if (playing) drawLine(g);

      // Glitch-Band
      if (S.glitch > 0) {
        var by = rnd(TOP, H - BOTTOM - 30) * DPR, bh = rnd(12, 34) * DPR, off = rnd(-14, 14) * DPR;
        g.setTransform(1, 0, 0, 1, 0, 0);
        g.drawImage(canvas, 0, by, canvas.width, bh, off, by, canvas.width, bh);
        g.fillStyle = 'rgba(0,250,245,0.06)'; g.fillRect(0, by, canvas.width, bh);
      }
    }
    function easeBack(t) { var c = 1.9; return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); }
    function drawRing(g) {
      var crash = S.crash > 0, stun = S.stun > 0;
      var x = ring.x, y = ring.y;
      if (S.combo > 1 && !crash) {
        var gr = g.createRadialGradient(x, y, R * 0.6, x, y, R * 2.2);
        gr.addColorStop(0, 'rgba(0,250,245,' + (0.05 * S.combo).toFixed(3) + ')'); gr.addColorStop(1, 'rgba(0,250,245,0)');
        g.fillStyle = gr; g.beginPath(); g.arc(x, y, R * 2.2, 0, 7); g.fill();
      }
      g.beginPath(); g.arc(x, y, R, 0, 7);
      g.fillStyle = crash ? 'rgba(255,46,136,0.10)' : 'rgba(0,250,245,0.06)'; g.fill();
      g.lineWidth = 1 * U; g.strokeStyle = crash ? 'rgba(255,46,136,0.35)' : 'rgba(0,250,245,0.22)'; g.stroke();
      var n = 14;
      for (var i = 0; i < n; i++) {
        var a = ring.rot + i / n * 6.283;
        var jr = R + (stun ? rnd(-5, 5) * U : 0) + (crash ? Math.sin(S.t * 13 + i) * 5 * U : 0);
        var px = x + Math.cos(a) * jr, py = y + Math.sin(a) * jr;
        var sz = (1.5 + 2.4 * (0.5 + 0.5 * Math.sin(i * 1.9))) * U;
        g.fillStyle = crash ? mix('#ff2e88', '#ffb3d4', i / n) : mix(BLUE, CYAN, (Math.sin(i / n * 6.283) + 1) / 2);
        g.beginPath(); g.arc(px, py, sz, 0, 7); g.fill();
      }
      g.beginPath(); g.arc(x, y, 2.4 * U, 0, 7); g.fillStyle = crash ? KICK : CYAN; g.fill();
    }
    function drawLine(g) {
      var lh = 34 * U, base = H - 16, top = base - lh;
      g.strokeStyle = 'rgba(219,234,254,0.10)'; g.lineWidth = 1;
      g.setLineDash([3, 4]);
      g.beginPath();
      g.moveTo(W / 3, top - 6); g.lineTo(W / 3, base); g.moveTo(W * 2 / 3, top - 6); g.lineTo(W * 2 / 3, base);
      g.moveTo(0, base + 0.5); g.lineTo(W, base + 0.5);
      g.stroke(); g.setLineDash([]);
      g.font = '600 ' + (10 * U).toFixed(1) + 'px Inter, sans-serif'; g.textAlign = 'left'; g.textBaseline = 'bottom';
      g.fillStyle = 'rgba(219,234,254,0.45)'; g.fillText('FOKUS-LINIE', 10, top - 4);
      var L = S.line; if (L.length < 2) return;
      var step = W / (ROUND * 4);
      g.beginPath(); g.moveTo(0, base);
      for (var i = 0; i < L.length; i++) g.lineTo(i * step, base - L[i] * lh);
      g.lineTo((L.length - 1) * step, base); g.closePath();
      var gr = g.createLinearGradient(0, top, 0, base);
      gr.addColorStop(0, 'rgba(0,250,245,0.28)'); gr.addColorStop(1, 'rgba(0,250,245,0)');
      g.fillStyle = gr; g.fill();
      g.beginPath();
      for (i = 0; i < L.length; i++) { var yy = base - L[i] * lh; if (i) g.lineTo(i * step, yy); else g.moveTo(0, yy); }
      g.strokeStyle = S.crash > 0 ? KICK : CYAN; g.lineWidth = 2 * U; g.stroke();
      var ex = (L.length - 1) * step, ey = base - L[L.length - 1] * lh;
      g.beginPath(); g.arc(ex, ey, 3.5 * U, 0, 7); g.fillStyle = '#fff'; g.fill();
    }

    /* ---------- Ende und Auswertung ---------- */
    function rate(o) { var n = o.h + o.m + o.e * 1.5; return n ? o.h / n : 0; }
    function finish() {
      S.mode = 'over';
      for (var i = 0; i < S.notes.length; i++) S.notes[i].el.remove();
      S.notes = []; S.syn = [];
      float(W / 2, H / 2, 'ZEIT VORBEI!', '#ffffff', true);
      tone(783.99, 0.15, 'sine', 0.06); tone(1046.5, 0.15, 'sine', 0.06, null, 0.1); tone(1567.98, 0.3, 'sine', 0.06, null, 0.2);
      show(hud, false); show(muteBtn, false);
      setTimeout(showResult, autoplay ? 200 : 1000);
    }
    // Erwartete Trefferquote bei sehr gutem Spiel je Phase (gemessen mit schnellen Bots nach Erhöhung der Schwierigkeit, 09.10.2026).
    // Phase 2 und 3 sind absichtlich schwerer; die Wertung rechnet das heraus, damit „bestmöglich“ überall 100 ergibt.
    var EXPECT = [0.97, 0.8, 0.62];
    function nrate(o, ph) { var n = o.h + o.m + o.e * 1.5; return n ? Math.min(1, o.h / n / EXPECT[ph]) : null; }
    function evaluate() {
      var pr = S.ph.map(function (o, i) { return nrate(o, i); }).filter(function (v) { return v !== null; });
      var treff = Math.round(100 * pr.reduce(function (a, b) { return a + b; }, 0) / (pr.length || 1));
      // Konstanz: sechs Abschnitte à 10 s, jeweils gegen die Erwartung ihrer Phase
      var rates = [];
      for (var i = 0; i < 6; i++) {
        var a = S.buckets[i * 2], b = S.buckets[i * 2 + 1];
        var v = nrate({ h: a.h + b.h, m: a.m + b.m, e: a.e + b.e }, Math.floor(i / 2));
        if (v !== null) rates.push(v);
      }
      var mean = rates.reduce(function (x, y) { return x + y; }, 0) / (rates.length || 1);
      var sd = Math.sqrt(rates.reduce(function (x, y) { return x + (y - mean) * (y - mean); }, 0) / (rates.length || 1));
      var konst = rates.length < 3 ? 0 : clamp(Math.round(100 - sd * 200), 0, 100);
      konst = Math.min(konst, treff + 25);
      var score = Math.round(treff * 0.55 + konst * 0.45);
      var r1 = nrate(S.ph[0], 0) || 0, r3 = nrate(S.ph[2], 2) || 0;
      // Eichhörnchen: ab 5 berührten Nachrichten (Tab-Wechsel zählt mit); hohle Punkte zählen hier nicht
      var distract = S.n.notes + S.n.away;
      var errors = distract + S.n.decoys + S.n.kicks;
      var key = score >= 95 ? 'laser'
        : S.n.best >= 30 ? 'kette'
        : S.n.kicks >= 3 ? 'blitz'
        : distract >= 5 ? 'hoernchen'
        : S.n.decoys >= 5 ? 'glaeubig'
        : errors === 0 && treff < 70 ? 'vorsicht'
        : (r3 < r1 - 0.15 || S.n.kicks >= 2) ? 'sprinter'
        : r3 > r1 + 0.12 ? 'spaet'
        : konst < 55 ? 'achterbahn'
        : 'linie';
      var vals = { n: key === 'hoernchen' ? distract : S.n.best, k: S.n.kicks, d: S.n.decoys };
      var fill = function (t) { return t.replace(/\{(\w)\}/g, function (m, v) { return vals[v]; }); };
      var base = PROFILES[key];
      return { treff: treff, konst: konst, score: score, key: key, profile: { name: base.name, quote: fill(base.quote), desc: fill(base.desc) } };
    }
    var lastRes = null;
    function showResult() {
      var res = evaluate(); lastRes = res;
      var prevLine = store('linie'), best = store('best') || 0, isBest = res.score > best;
      if (isBest) store('best', res.score);
      store('linie', downsample(S.line, 120));
      track('ende', { score: res.score, profil: res.key, punkte: Math.round(S.points) });

      q('.sf-profile').textContent = res.profile.name;
      q('.sf-quote').textContent = '„' + res.profile.quote + '“';
      q('.sf-desc').textContent = res.profile.desc;
      q('.sf-stats').innerHTML =
        '<li><b>' + Math.round(S.points) + '</b><span>Punkte</span></li>' +
        '<li><b>' + S.n.hits + '</b><span>gesammelt</span></li>' +
        '<li><b>' + S.n.best + '</b><span>längste Serie</span></li>' +
        '<li><b>' + (S.n.notes + S.n.away) + '</b><span>Nachrichten</span></li>' +
        '<li><b>' + S.n.decoys + '</b><span>Fälschungen</span></li>' +
        '<li><b>' + S.n.kicks + '</b><span>Kicks</span></li>';
      show(scrResult, true); scrResult.scrollTop = 0;
      root.classList.toggle('sf-new-best', isBest);
      var bestEl = q('.sf-best'); bestEl.textContent = 'Bestwert: ' + Math.max(best, res.score);
      q('.sf-l-ghost').hidden = !prevLine;

      // Hochzählen, sobald der Score ins Bild scrollt
      var sEl = q('.sf-score b'), bt = q('.sf-bar-t'), bk = q('.sf-bar-k');
      sEl.textContent = '0'; bt.querySelector('b').textContent = bk.querySelector('b').textContent = '0';
      bt.querySelector('u').style.width = bk.querySelector('u').style.width = '0%';
      var count = function () { var t0 = performance.now(), dur = autoplay ? 10 : 1100; (function tick(now) {
        var k = clamp((now - t0) / dur, 0, 1), e = 1 - Math.pow(1 - k, 3);
        sEl.textContent = Math.round(res.score * e);
        bt.querySelector('b').textContent = Math.round(res.treff * e);
        bk.querySelector('b').textContent = Math.round(res.konst * e);
        bt.querySelector('u').style.width = (res.treff * e) + '%';
        bk.querySelector('u').style.width = (res.konst * e) + '%';
        if (k < 1) requestAnimationFrame(tick);
      })(t0); };
      if (window.IntersectionObserver && !autoplay) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); count(); } }, { root: scrResult, threshold: 0.6 });
        io.observe(q('.sf-scorebox'));
      } else count();
      drawChart(q('.sf-chart canvas'), downsample(S.line, 120), prevLine);
      if (isBest && best > 0) { tone(1046.5, 0.2, 'sine', 0.06, null, 0.3); tone(1318.5, 0.3, 'sine', 0.06, null, 0.45); }
    }
    function downsample(a, n) {
      if (!a.length) return [];
      var out = []; for (var i = 0; i < n; i++) out.push(+a[Math.min(a.length - 1, Math.floor(i / n * a.length))].toFixed(3));
      return out;
    }
    function drawChart(c, line, ghost) {
      var w = c.parentNode.clientWidth || 300, h = 110, dpr = DPR;
      c.width = w * dpr; c.height = h * dpr; c.style.width = w + 'px'; c.style.height = h + 'px';
      var g = c.getContext('2d'); g.scale(dpr, dpr);
      plot(g, 0, 0, w, h, line, ghost, 1);
    }
    function plot(g, x0, y0, w, h, line, ghost, k) {
      var pad = 18 * k, base = y0 + h - pad, top = y0 + 8 * k, lh = base - top;
      g.strokeStyle = 'rgba(219,234,254,0.14)'; g.lineWidth = 1 * k; g.setLineDash([3 * k, 4 * k]);
      g.beginPath();
      for (var p = 1; p < 3; p++) { g.moveTo(x0 + w * p / 3, top); g.lineTo(x0 + w * p / 3, base); }
      g.moveTo(x0, base); g.lineTo(x0 + w, base); g.stroke(); g.setLineDash([]);
      g.fillStyle = 'rgba(219,234,254,0.5)'; g.font = '600 ' + (10 * k) + 'px Inter, sans-serif'; g.textBaseline = 'top'; g.textAlign = 'center';
      ['Sammeln', 'Filtern', 'Durchhalten'].forEach(function (n, i) { g.fillText(n.toUpperCase(), x0 + w * (i + 0.5) / 3, base + 5 * k); });
      function path(l) {
        g.beginPath();
        for (var i = 0; i < l.length; i++) { var xx = x0 + i / (l.length - 1) * w, yy = base - l[i] * lh; if (i) g.lineTo(xx, yy); else g.moveTo(xx, yy); }
      }
      if (ghost && ghost.length > 1) { path(ghost); g.strokeStyle = 'rgba(219,234,254,0.35)'; g.lineWidth = 1.5 * k; g.setLineDash([4 * k, 4 * k]); g.stroke(); g.setLineDash([]); }
      if (line.length > 1) {
        path(line); g.lineTo(x0 + w, base); g.lineTo(x0, base); g.closePath();
        var gr = g.createLinearGradient(0, top, 0, base); gr.addColorStop(0, 'rgba(0,250,245,0.30)'); gr.addColorStop(1, 'rgba(0,250,245,0)');
        g.fillStyle = gr; g.fill();
        path(line); g.strokeStyle = CYAN; g.lineWidth = 2.5 * k; g.lineJoin = 'round'; g.stroke();
      }
    }

    /* ---------- Teilen-Karte ---------- */
    function card() {
      var res = lastRes, c = document.createElement('canvas'); c.width = 1080; c.height = 1920;
      var g = c.getContext('2d');
      g.fillStyle = BG; g.fillRect(0, 0, 1080, 1920);
      var gr = g.createRadialGradient(540, 700, 0, 540, 700, 1100);
      gr.addColorStop(0, 'rgba(0,120,160,0.30)'); gr.addColorStop(1, 'rgba(0,0,0,0)'); g.fillStyle = gr; g.fillRect(0, 0, 1080, 1920);
      g.strokeStyle = 'rgba(0,250,245,0.05)'; g.lineWidth = 2; g.beginPath();
      for (var x = 0; x <= 1080; x += 72) { g.moveTo(x, 0); g.lineTo(x, 1920); }
      for (var y = 0; y <= 1920; y += 72) { g.moveTo(0, y); g.lineTo(1080, y); }
      g.stroke();
      // Netzwerk als Hintergrund-Motiv
      if (S.net.length > 1) {
        var sx = 1000 / W, sy = 1100 / H;
        g.strokeStyle = 'rgba(0,250,245,0.10)'; g.lineWidth = 2.5; g.beginPath();
        S.net.forEach(function (p, i) { var px = 40 + p.x * sx, py = 380 + p.y * sy; if (i) g.lineTo(px, py); else g.moveTo(px, py); });
        g.stroke();
        g.fillStyle = 'rgba(0,250,245,0.22)';
        S.net.forEach(function (p) { g.beginPath(); g.arc(40 + p.x * sx, 380 + p.y * sy, 5, 0, 7); g.fill(); });
      }
      if (logoImg && logoImg.complete && logoImg.naturalWidth) {
        var lw = 380, lh = lw * logoImg.naturalHeight / logoImg.naturalWidth;
        g.drawImage(logoImg, 540 - lw / 2, 120, lw, lh);
      }
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      g.fillStyle = 'rgba(219,234,254,0.7)'; g.font = '600 38px Inter, sans-serif';
      g.fillText('MEIN FOKUS-PROFIL', 540, 420);
      fit(g, res.profile.name.toUpperCase(), 540, 560, 960, 132, '#ffffff');
      g.fillStyle = '#dbeafe'; g.font = '500 46px Inter, sans-serif';
      wrap(g, '„' + res.profile.quote + '“', 540, 660, 900, 62);
      g.fillStyle = CYAN; g.font = '700 330px Syne, "Arial Black", sans-serif';
      g.fillText(String(res.score), 540, 1120);
      g.fillStyle = 'rgba(219,234,254,0.75)'; g.font = '600 34px Inter, sans-serif';
      g.fillText('FOKUS-SCORE · TREFFSICHERHEIT ' + res.treff + ' · KONSTANZ ' + res.konst, 540, 1250, 980);
      plot(g, 90, 1290, 900, 300, downsample(S.line, 120), null, 2.6);
      fit(g, 'Schaffst du 60 Sekunden?', 540, 1730, 940, 64, '#ffffff');
      g.fillStyle = CYAN; g.font = '600 42px Inter, sans-serif';
      g.fillText(cfg.shareUrl, 540, 1800);
      return c;
    }
    function fit(g, text, x, y, maxW, size, color) {
      do { g.font = '700 ' + size + 'px Syne, "Arial Black", sans-serif'; size -= 4; } while (g.measureText(text).width > maxW && size > 40);
      g.fillStyle = color; g.fillText(text, x, y);
    }
    function wrap(g, text, x, y, maxW, lh) {
      var words = text.split(' '), line = '';
      for (var i = 0; i < words.length; i++) {
        var test = line ? line + ' ' + words[i] : words[i];
        if (g.measureText(test).width > maxW && line) { g.fillText(line, x, y); line = words[i]; y += lh; } else line = test;
      }
      g.fillText(line, x, y);
    }
    q('.sf-share').addEventListener('click', function () {
      var btn = this;
      var ready = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('700 100px Syne'), document.fonts.load('600 40px Inter')]) : Promise.resolve();
      ready.catch(function () {}).then(function () {
        var c = card();
        c.toBlob(function (blob) {
          if (!blob) return;
          var file = new File([blob], 'stoerfeuer-' + lastRes.key + '.png', { type: 'image/png' });
          track('geteilt', { profil: lastRes.key });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({ files: [file], text: 'Mein Fokus-Profil: ' + lastRes.profile.name + '. Schaffst du 60 Sekunden? ' + cfg.shareUrl }).catch(function () {});
          } else {
            var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = file.name;
            document.body.appendChild(a); a.click(); a.remove();
            btn.textContent = 'Gespeichert ✓'; setTimeout(function () { btn.textContent = 'Teilen'; }, 2000);
          }
        }, 'image/png');
      });
    });

    /* ---------- Code, Opt-in, Buttons ---------- */
    q('.sf-copy').addEventListener('click', function () {
      var btn = this, done = function () { btn.textContent = 'Kopiert ✓'; track('code_kopiert'); setTimeout(function () { btn.textContent = 'Kopieren'; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cfg.code).then(done, done);
      else {
        var r = document.createRange(); r.selectNodeContents(q('.sf-code code'));
        var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
        try { document.execCommand('copy'); } catch (e) {} done();
      }
    });
    q('.sf-redeem').addEventListener('click', function () { track('code_eingeloest', { ziel: 'shop' }); });
    Array.prototype.forEach.call(root.querySelectorAll('.sf-buy'), function (a) {
      a.addEventListener('click', function () { track('code_eingeloest', { ziel: 'checkout', produkt: a.getAttribute('data-produkt') }); });
    });
    var nl = q('.sf-newsletter-link');
    if (nl) nl.addEventListener('click', function () { track('optin_geoeffnet'); });
    q('.sf-to-result').addEventListener('click', function () { q('.sf-kicker').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    var kl = q('.sf-klaviyo');
    if (kl) kl.addEventListener('click', function () {
      // Öffnet das bestehende Klaviyo-Formular (Auslöser „Custom trigger“); Einwilligung und Double-Opt-in laufen über Klaviyo
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', cfg.klaviyoForm]);
      track('optin_geoeffnet');
    });
    q('.sf-go').addEventListener('click', function () { if (audio.on) audioCtx(); startCountdown(); });
    q('.sf-again').addEventListener('click', startCountdown);
    q('.sf-resume').addEventListener('click', function () { show(scrAway, false); S.paused = false; last = performance.now(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && S.mode === 'play' && !S.paused) {
        S.paused = true; S.n.away++; stat('e'); quality(0, 0.4); breakStreak();
        show(scrAway, true);
      }
    });
    var best0 = store('best'); if (best0) q('.sf-best').textContent = 'Bestwert: ' + best0;

    /* ---------- Schleife ---------- */
    var last = performance.now();
    function loop(now) {
      var dt = Math.min(0.05, (now - last) / 1000) * speed; last = now;
      if (!S.paused) update(dt);
      render();
      requestAnimationFrame(loop);
    }
    if (window.ResizeObserver) new ResizeObserver(resize).observe(stage); else window.addEventListener('resize', resize);
    resize();
    if (record) {
      // Bildgenaue Aufnahme für Werbevideos: Zeit wird von außen weitergeschaltet
      window.__sf = {
        start: function () { fresh('play'); show(scrStart, false); show(hud, true); ring.x = W / 2; ring.y = H * 0.55; S.mode = 'play'; S.t = 0; setPhase(0); },
        tick: function (dt) { update(dt); render(); },
        bot: function (o) { botOpts = Object.assign(botOpts, o); },
        state: function () { var e = S.mode === 'over' || S.t >= 59.9 ? evaluate() : null; return { ph: S.ph, buckets: S.buckets, res: e && { score: e.score, treff: e.treff, konst: e.konst, key: e.key }, hits: S.n.hits, misses: S.n.misses, t: S.t, phase: S.phase, points: S.points, crash: S.crash, kicks: S.n.kicks, notes: S.n.notes, mode: S.mode, kickOnField: S.syn.some(function (x) { return x.kind === 'kick'; }) }; },
        cardFor: function (key, o) { lastRes = evaluate(); lastRes.key = key; lastRes.profile = PROFILES[key]; if (o) { lastRes.score = o.score; lastRes.treff = o.treff; lastRes.konst = o.konst; if (o.line) S.line = o.line; } return card().toDataURL('image/png'); },
        finish: function () { finish(); }
      };
      return;
    }
    requestAnimationFrame(loop);
    if (autoplay) { setTimeout(startCountdown, 100); window.__sfCard = function () { return card().toDataURL('image/png'); }; }
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-stoerfeuer]'), mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
